export default "__VITE_ASSET__Bzyh7ZIn__"